import { createSubjectSortCollator } from "./sortRowsBySubject";

export default function findSubjectJumpToIndex<T>(rows: readonly T[], getNormalizedSubject: (row: T) => string, descending: boolean, matchingString: string): number {
    if (matchingString === "" || rows.length === 0) {
        return -1;
    }
    const collator = createSubjectSortCollator();
    // Folder Jump To compares the unchanged input against normalized subjects using >= or <=.
    const index = rows.findIndex(row => {
        const comparison = collator.compare(getNormalizedSubject(row), matchingString);
        return descending ? comparison <= 0 : comparison >= 0;
    });
    return index >= 0 ? index : rows.length - 1;
}
